// Theme: winter-silence
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'winter-silence',
  name: 'WINTER SILENCE',
  tagline: 'WINTER SILENCE',
  description: 'Silencio de inverno. Azul-gelo calmo e imovel como neve.',
  category: 'organic-world',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#0F1520', '#1A2535', '#E0F2FE', '#E0F0F8'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '8px',
      '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.20)',
      '--shadow-card-active': '0 10px 24px color-mix(in srgb, var(--primary) 25%, transparent)'
    },
    shellClasses: 'font-sans theme-winter-silence'
  },
  colorVars: {
    '--accent': '#E0F2FE',
    '--accent-foreground': '#0F1520',
    '--background': '#0F1520',
    '--border': '#3A6A8A',
    '--card': '#1A2535',
    '--card-border-active': 'rgba(224, 242, 254, 0.36)',
    '--card-completed': '#172130',
    '--card-foreground': '#E0F0F8',
    '--card-glow': 'rgba(224, 242, 254, 0.06)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F1520',
    '--foreground': '#E0F0F8',
    '--hold-fill': '#E0F2FE',
    '--input': '#3A6A8A',
    '--modal-bg': '#0F1520',
    '--modal-border': '#3A6A8A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--muted': '#3A6A8A',
    '--muted-foreground': '#E0F0F8',
    '--nav-active': '#E0F2FE',
    '--nav-bg': '#1A2535',
    '--popover': '#1A2535',
    '--popover-foreground': '#E0F0F8',
    '--primary': '#E0F2FE',
    '--primary-foreground': '#0F1520',
    '--ring': '#E0F2FE',
    '--secondary': '#3A6A8A',
    '--secondary-foreground': '#E0F0F8',
    '--streak': '#E0F2FE',
    '--success': '#22c55e',
    '--success-foreground': '#0F1520',
    '--xp': '#E0F2FE',
    '--xp-bg': '#1A2535'
  },
  resolvedVars: {
    '--accent': '#E0F2FE',
    '--accent-foreground': '#0F1520',
    '--accent-foreground-hsl': '219 36% 9%',
    '--accent-foreground-oklch': 'from #0F1520 l c h',
    '--accent-hsl': '204 94% 94%',
    '--accent-oklch': 'from #E0F2FE l c h',
    '--background': '#0F1520',
    '--background-hsl': '219 36% 9%',
    '--background-oklch': 'from #0F1520 l c h',
    '--border': '#3A6A8A',
    '--border-hsl': '204 41% 38%',
    '--border-oklch': 'from #3A6A8A l c h',
    '--border-w': '1px',
    '--card': '#1A2535',
    '--card-border-active': 'rgba(224, 242, 254, 0.36)',
    '--card-completed': '#172130',
    '--card-completed-hsl': '216 35% 14%',
    '--card-completed-oklch': 'from #172130 l c h',
    '--card-foreground': '#E0F0F8',
    '--card-foreground-hsl': '200 63% 93%',
    '--card-foreground-oklch': 'from #E0F0F8 l c h',
    '--card-glow': 'rgba(224, 242, 254, 0.06)',
    '--card-hsl': '216 34% 15%',
    '--card-oklch': 'from #1A2535 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F1520',
    '--destructive-foreground-hsl': '219 36% 9%',
    '--destructive-foreground-oklch': 'from #0F1520 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#E0F0F8',
    '--foreground-hsl': '200 63% 93%',
    '--foreground-oklch': 'from #E0F0F8 l c h',
    '--hold-fill': '#E0F2FE',
    '--hold-fill-hsl': '204 94% 94%',
    '--hold-fill-oklch': 'from #E0F2FE l c h',
    '--input': '#3A6A8A',
    '--input-hsl': '204 41% 38%',
    '--input-oklch': 'from #3A6A8A l c h',
    '--modal-bg': '#0F1520',
    '--modal-bg-hsl': '219 36% 9%',
    '--modal-bg-oklch': 'from #0F1520 l c h',
    '--modal-border': '#3A6A8A',
    '--modal-border-hsl': '204 41% 38%',
    '--modal-border-oklch': 'from #3A6A8A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--muted': '#3A6A8A',
    '--muted-foreground': '#E0F0F8',
    '--muted-foreground-hsl': '200 63% 93%',
    '--muted-foreground-oklch': 'from #E0F0F8 l c h',
    '--muted-hsl': '204 41% 38%',
    '--muted-oklch': 'from #3A6A8A l c h',
    '--nav-active': '#E0F2FE',
    '--nav-active-hsl': '204 94% 94%',
    '--nav-active-oklch': 'from #E0F2FE l c h',
    '--nav-bg': '#1A2535',
    '--nav-bg-hsl': '216 34% 15%',
    '--nav-bg-oklch': 'from #1A2535 l c h',
    '--popover': '#1A2535',
    '--popover-foreground': '#E0F0F8',
    '--popover-foreground-hsl': '200 63% 93%',
    '--popover-foreground-oklch': 'from #E0F0F8 l c h',
    '--popover-hsl': '216 34% 15%',
    '--popover-oklch': 'from #1A2535 l c h',
    '--primary': '#E0F2FE',
    '--primary-foreground': '#0F1520',
    '--primary-foreground-hsl': '219 36% 9%',
    '--primary-foreground-oklch': 'from #0F1520 l c h',
    '--primary-hsl': '204 94% 94%',
    '--primary-oklch': 'from #E0F2FE l c h',
    '--radius': '8px',
    '--ring': '#E0F2FE',
    '--ring-hsl': '204 94% 94%',
    '--ring-oklch': 'from #E0F2FE l c h',
    '--secondary': '#3A6A8A',
    '--secondary-foreground': '#E0F0F8',
    '--secondary-foreground-hsl': '200 63% 93%',
    '--secondary-foreground-oklch': 'from #E0F0F8 l c h',
    '--secondary-hsl': '204 41% 38%',
    '--secondary-oklch': 'from #3A6A8A l c h',
    '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--shadow-card-active': '0 10px 24px color-mix(in srgb, var(--primary) 25%, transparent)',
    '--streak': '#E0F2FE',
    '--streak-hsl': '204 94% 94%',
    '--streak-oklch': 'from #E0F2FE l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0F1520',
    '--success-foreground-hsl': '219 36% 9%',
    '--success-foreground-oklch': 'from #0F1520 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(204 94% 94% / 0.15)',
    '--xp': '#E0F2FE',
    '--xp-bg': '#1A2535',
    '--xp-bg-hsl': '216 34% 15%',
    '--xp-bg-oklch': 'from #1A2535 l c h',
    '--xp-hsl': '204 94% 94%',
    '--xp-oklch': 'from #E0F2FE l c h'
  }
}
